// Header.js
import React, { useState, useEffect } from 'react';
import Modal from '../ui/Modal';
import useModal from '../../hooks/useModal'
import { useLocation } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faDisplay, faUserLarge} from '@fortawesome/free-solid-svg-icons';
import * as Yup from 'yup';
import PostForm from '../../components/shared/PostForm';




const Header = () => {
  const location = useLocation();
  const isSharehousePage = /^\/sharehouse\/\d+\/$/.test(location.pathname + location.search);
  const isTransactionPage = /^\/transaction\/\d+\/$/.test(location.pathname + location.search);
  const isJobPage = /^\/job\/\d+\/$/.test(location.pathname + location.search);
  const isTopPage = /^\/$/.test(location.pathname + location.search);
  const isSpecificPage = /^\/chat\/[a-f0-9]{64}\/\d+\/\d+\/?.*$/.test(location.pathname + location.search);
  const isCleaPage = isSharehousePage || isTransactionPage || isJobPage || isTopPage;
  const [isLogin, setIsLogin] = useState(false)
  const { isOpen, openModal, closeModal } = useModal();
  const [currentPage, setCurrentPage] = useState("login");
  const [initialValues, setInitialValues] = useState(null);
  const [isWrong, setIsWrong] = useState(false);
  const backUrl = process.env.REACT_APP_API_URL;

  console.log(isWrong)

  const handlePageChange = (page) => {
    setCurrentPage(page);
  };
  const handleLogin = async () => {
    try {
      // サーバー側でリダイレクトURLを取得し、フロントエンドでリダイレクト
      const response = await fetch(`${backUrl}/api/line/login/`,{
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
        credentials: 'include',
      });
      if (response.ok) {
        const data = await response.json();
        // ここで取得したリダイレクトURLに移動
        window.location.href = data.redirect_url;  // サーバーから返されたURLに遷移
      } else {
        console.error('LINEログインURLの取得に失敗');
      }
    } catch (error) {
      console.error('LINEログインURLの取得に失敗:', error);
    }
  };

  const formFields = {
    login_form: [
      { name: 'ID', type: 'text', label: 'Id', placeholder: 'IDを入力してください', validation: Yup.string().required('必須'), initialValue: '' },
      { name: 'PASSWORD', type: 'text', label: 'Password', placeholder: 'パスワードを入力してください', validation: Yup.string().required('必須'), initialValue: '' },
    ],
    create_user_form: [
      { name: 'custom_id', type: 'text', label: 'ID', validation: Yup.string().required('必須').min(4, 'IDは最低4文字以上で入力してください').max(20, 'IDは20文字以下で入力してください').matches(/^[a-zA-Z0-9_]+$/, 'IDは英数字とアンダースコアのみ使用できます'), initialValue: '' },
      { name: 'username', type: 'text', label: 'User Name', validation: Yup.string().required('必須') .min(3, 'ユーザーネームは最低3文字以上で入力してください').max(15, 'ユーザーネームは15文字以下で入力してください'), initialValue: '' },
      { name: 'email', type: 'text', label: 'Email Address', validation: Yup.string().required('必須').email('正しいメールアドレス形式で入力してください'), validation: Yup.string().required('必須'), initialValue: '' },
      { name: 'password', type: 'text', label: 'Password', validation: Yup.string().required('必須').min(8, 'パスワードは最低8文字以上で入力してください'), initialValue: '' },
      { name: 'password_conf', type: 'text', label: 'Password　(確認用)', validation: Yup.string().required('必須').oneOf([Yup.ref('password')], 'パスワードが一致しません'), initialValue: '' },
    ]
  };

  // デフォルトのフィールドを設定
  const formConfig = {
    fields: formFields[currentPage] || []
  };

  useEffect(() => {
    const token = localStorage.getItem('token');
    if (token) {
      setIsLogin(true);
    }
  }, []);

  return (
    <div>
    <header>
      <div className={isSpecificPage ? 'header color' :isCleaPage? 'clea' : 'header'}>
        <img className="header__image" src="/media/logo.svg" alt="GCコアラロゴ" />
        <div className='header__logo'>
          <div className='logo'>Gold</div> <div className='logo'>Coast Koala</div>
        </div>
        {isLogin === true ? (
          <div className="header__login">
            <a href='/mypage'>
              <FontAwesomeIcon icon={faUserLarge} style={{color: "#015b02",}}/>
              <span>MY PAGE</span>
            </a>
          </div>
        ):(
          <div className="header__login"onClick={() => { openModal(); handlePageChange("login"); }}>
            <img src="/media/login.svg" alt="ログイン" />
            <span>ログイン</span>
          </div>
        )}
      </div>
    </header>
    <Modal 
      isOpen={isOpen} 
      closeModal={closeModal} 
      currentPage={currentPage} 
      setCurrentPage={setCurrentPage} 
      handleLogin={handleLogin}
      handlePageChange={handlePageChange}
      className="login"
    >
      { currentPage === "login_form" ? (
        <>
        <h2 className='login__ttl'>SIGN IN</h2>
        <div className='login__form'>
          { isWrong === true ?(
            <p className='orange' style={{ display: 'block', textAlign: 'center' }}>ログイン情報が間違っています</p>
          ):null}
          <PostForm
          title = {'LOGIN'}
          formConfig={formConfig}
          type="login_form"
          apiUrl={{submit: `${backUrl}/api/login/`}}
          setCurrentPage={setCurrentPage}
          setIsLogin={setIsLogin}
          setIsWrong={setIsWrong}
          initialValues={initialValues || formConfig.fields.reduce((acc, field) => {
            acc[field.name] = field.initialValue || (field.type === 'checkbox' ? [] : '');
            return acc;
          }, {})}
          />
        </div>
        </>
        ) : currentPage === "creat_user" ? (
          <>
          <h2 className='login__ttl'>SIGN UP</h2>
          <div className='signup'>
          <div className='signup__line'>
            <h3>LINEで登録はこちらから</h3>
            <span>ボタンひとつで簡単登録！</span>
            <span>メッセージ受信時にLINEで通知！</span>
            <div className='login__btn line' onClick={handleLogin}>
              <span>LINEで登録</span>
            </div>
          </div>
          <div className='signup__mail'>
            <span onClick={() => handlePageChange("create_user_form")}>メールアドレスで登録はこちら</span>
          </div>
          </div>
          </>
        ) : currentPage === "create_user_form" ? (
          <>
          <h2 className='login__ttl'>SIGN UP</h2>
          <div className='signup__form'>
            <PostForm
            title = {'SIGN UP'}
            formConfig={formConfig}
            type="create_user"
            apiUrl={{submit: `${backUrl}/api/creat_user/`}}
            setCurrentPage={setCurrentPage}
            setIsLogin={setIsLogin}
            initialValues={initialValues || formConfig.fields.reduce((acc, field) => {
              acc[field.name] = field.initialValue || (field.type === 'checkbox' ? [] : '');
              return acc;
            }, {})}
            />
          </div>
          </>
        ): currentPage === "creat_user_comp" ? (
          <>
          <h2 className='login__ttl'>SIGN UP</h2>
          <div className='login__comp'>
            <span>ユーザー登録が完了しました</span>
            <p>引き続きGold Coast Koalaをお楽しみください</p>
          </div>
          </>
        ): currentPage === "login_comp" ?(
          <>
          <h2 className='login__ttl'>SIGN IN</h2>
          <div className='login__comp'>
            <span>ログインが完了しました</span>
            <p>引き続きGold Coast Koalaをお楽しみください</p>
          </div>
          </>
        ):null}
  </Modal>
  </div>
  )
};

export default Header;
